import React, { useCallback, useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useNotify } from 'react-admin';

const NavigationPrompt = ({
  hasEditPermission,
  hasComposeEmailPermission,
  isMup,
  creation,
  history,
  adjustMatchingPath,
  location,
  when,
  children
}) => {
  const [nextLocation, setNextLocation] = useState({ pathname: null });
  const [openModal, setOpenModal] = useState(false);
  const unblock = useRef();
  const notify = useNotify();

  const blockNavigation = useCallback(
    newLocation => {
      const position1 = adjustMatchingPath
        ? adjustMatchingPath(newLocation.pathname)
        : newLocation.pathname;
      const position2 = adjustMatchingPath
        ? adjustMatchingPath(location.pathname)
        : location.pathname;
      if (when) {
        setOpenModal(position1 !== position2); // Not open the modal if we navigate between the same Form tabs
        setNextLocation(newLocation);
      }

      if (position1 === position2) {
        return true;
      }
      return !when;
    },
    [adjustMatchingPath, location.pathname, when]
  );

  const handleUnblock = useCallback(() => {
    let hasPermission =
      hasEditPermission === undefined ? true : hasEditPermission;
    if (!hasPermission) {
      if (hasComposeEmailPermission === true && isMup === true) {
        hasPermission = true;
      }
    }
    unblock.current && unblock.current();
    !hasPermission &&
      when &&
      notify('ra.message.no_edit_permission', { type: 'error' });
  }, [hasEditPermission, hasComposeEmailPermission, isMup, when, notify]);
  useEffect(() => {
    unblock.current =
      creation || hasEditPermission ? history.block(blockNavigation) : () => {};
    return handleUnblock;
  }, [creation, hasEditPermission, blockNavigation, handleUnblock, history]);

  const onCancel = useCallback(() => {
    setNextLocation(null);
    setOpenModal(false);
  }, []);

  const onConfirm = useCallback(() => {
    unblock.current && unblock.current();
    // sometimes !, the history is not coherent with the document location, so we need to check to prevent an error on push
    if (
      history.location.pathname === nextLocation.pathname ||
      document.location.hash.substr(1) === nextLocation.pathname
    ) {
      history.replace(nextLocation.pathname);
    } else {
      if (nextLocation.pathname) {
        history.push(nextLocation.pathname);
      }
    }
  }, [history, nextLocation]);

  return (
    <div>
      {creation || hasEditPermission ? (
        children(openModal, onConfirm, onCancel, blockNavigation)
      ) : (
        <></>
      )}
    </div>
  );
};

NavigationPrompt.propTypes = {
  when: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired
};

export default withRouter(NavigationPrompt);
